import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
    CCard, CModal,
    CCardBody, CModalHeader,
    CButton, CModalBody, CCardText,
    CCardHeader, CDropdown,
    CCol, CFormLabel, CCardTitle,
    CDataTable, CFormTextarea,
    CRow, CForm,
    CPagination, CFormText, CFormInput,
    /*CForm,CForm,CFormText, CDropdownItem,
  CFormLabel,CFormInput,CFormInputGroup,CFormInputGroupText,  CFormTextarea*/
} from 'compat/coreui'

import axios from 'axios';
// import { postData } from '../../../helpers/api';
import { ToastContainer, toast } from 'react-toastify';



const Contact = () => {
    
    return (
        <div className="contact-us-page">
        <CCard className="business-dashboard">
            <CRow>
                <CCol className="mb-5 contact-page" lg={8}>
                    <h2>Contact JointPlug</h2>
                    <p><span>Attention: </span> We are NOT a dispensary! You are contacting Where's Weed.com directly. Our site does not provide any legal or medical services whatsoever. Please direct those questions to businesses in your area.</p>
                   <CForm>
                    <CForm>
                      <CRow>
                        <CCol lg={6}>
                            <CFormLabel>Name<span className="required"></span></CFormLabel>
                            <CFormInput
                              type="text"
                              className="form-control"
                              name="name"
                              />
                              <CFormLabel>Company<span className="required"></span></CFormLabel>
                              <CFormInput type="text" className="form-control" name="company" />
                              <CFormLabel>Phone<span className="required"></span></CFormLabel>
                              <CFormInput type="text" className="form-control" name="phone" />
                              <CFormLabel>Email<span className="required"></span></CFormLabel>
                              <CFormInput type="email" className="form-control" name="email" />
                                <CFormLabel>Department</CFormLabel>
                                  <select type="select" className="custom-select">
                                    <option value="">Select </option>
                                    <option value="customer service">Customer Service</option>
                                    <option value="general comment">General Comment</option>
                                    <option value="billing">Billing</option>
                                    <option value="advertising">Advertising</option>
                                    <option value="legal">Legal</option>
                                  </select>
                        </CCol>
                        <CCol lg={6} className="pt-4">
                          <CFormTextarea
                              type="text"
                              className="form-control"
                              name="message"
                              placeholder="Type your message here..."
                              />
                              <CButton color="success" className="mt-4 pr-4 pl-4">Send</CButton>
                        </CCol>
                      </CRow>
                    </CForm>
                  </CForm>
                </CCol>
                <CCol  lg={4} className="contact-page-card">
                  <CCard>
                    <CCardHeader>
                      <CCardTitle>Questions? Call Us!</CCardTitle>
                      <span>(888) 400-0000</span>
                    </CCardHeader>
                    <CCardBody>
                      <CCardText>
                        <h3>Lost your password?</h3>
                        <p>Having troubles logging in? Click here to reset your password.</p>
                      </CCardText>
                      <CCardText>
                        <h3>Business Registration</h3>
                        <p>Are you a business owner? Click here to register or claim your business profile on Where's Weed.</p>
                      </CCardText>
                      <CCardText>
                        <h3>Press</h3>
                        <p>For our mediakit and press inquiries, please use the contact form to reach us.</p>
                      </CCardText>
                    </CCardBody>
                  </CCard>
                </CCol>
            </CRow>
        </CCard>
        </div>
    )
}

export default Contact;
